import axios from "axios";
import { BASE_URL } from "../constants";
import { getEmptyGetResponse } from "./emptyResponses";

async function Get(path, token, queryObj, abortController = {}) {
  try {
    const emptyResponse = getEmptyGetResponse(path);
    if (emptyResponse) {
      return emptyResponse;
    }

    let url = BASE_URL + path;
    const header = {
      headers: token
        ? {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        : {
            "Content-Type": "application/json",
          },
      signal: abortController.signal,
    };

    if (queryObj) {
      let queryString = "";
      Object.keys(queryObj).forEach((val) => {
        const value = queryObj[val];
        if (value !== undefined && value !== null && String(value).length > 0) {
          if (queryString.length > 0) {
            queryString += `&${val}=${encodeURIComponent(value)}`;
          } else {
            queryString += `?${val}=${encodeURIComponent(value)}`;
          }
        }
      });
      url += queryString;
    }

    const { data } = await axios.get(url, header);
    return data;
  } catch (error) {
    if (error.response?.status === 401) {
      const theme = localStorage.getItem("birchwood_theme");
      localStorage.clear();
      if (theme) localStorage.setItem("birchwood_theme", theme);
      window.location.href = "/signin?error_code=session_expired";
    }

    const payload = error.response?.data;
    const fallback = error.message || "Request failed";
    let message = fallback;
    let extra = { status: false };
    if (typeof payload === "string") {
      const pre = payload.match(/<pre>([^<]+)<\/pre>/i);
      message = pre?.[1]?.trim() || fallback;
    } else if (payload && typeof payload === "object") {
      message =
        typeof payload.message === "string" && !payload.message.includes("<")
          ? payload.message
          : fallback;
      extra = { ...payload, status: payload.status ?? false, message };
    }
    const requestError = new Error(message);
    Object.assign(requestError, extra);
    throw requestError;
  }
}

export { Get };
